/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2016
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['underscore'], function(_) {

	var ArcheType = [{
		'id': 'area',
		'uri': '/visualizations/_archetypes/area',
		'name': 'Area',
		'description': 'Area',
		'iconUri': '/visualizations/stackAreaChart/icon',
		'minimalVisId': 'areaChart',
		'visIds': [
			'areaChart',
			'stackAreaChart'
		],
		'dataSlots': [{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'stackAreaChart'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		},
		{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'areaChart',
				'stackAreaChart'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Axis label',
			'id': 'categories',
			'categoryTargets': [
				'areaChart',
				'stackAreaChart'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		}
		]
	},
	{
		'id': 'bubble',
		'uri': '/visualizations/_archetypes/bubble',
		'name': 'Bubble',
		'description': 'Bubble',
		'iconUri': '/visualizations/bubbleChart/icon',
		'minimalVisId': 'bubbleChart',
		'visIds': [
			'bubbleChart'
		],
		'dataSlots': [{
			'caption': 'Vertical axis',
			'id': 'yAxis',
			'icon': 'yAxis',
			'categoryTargets': [

			],
			'measureTargets': [
				'bubbleChart'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Horizontal axis',
			'id': 'xAxis',
			'icon': 'xAxis',
			'categoryTargets': [

			],
			'measureTargets': [
				'bubbleChart'
			],
			'sortOrder': '2'
		},
		{
			'caption': 'Size by',
			'id': 'size',
			'icon': 'sizeBy',
			'categoryTargets': [

			],
			'measureTargets': [
				'bubbleChart'
			],
			'sortOrder': '4'
		},
		{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'bubbleChart'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		}
		]
	},
	{
		'id': 'clusterBar',
		'uri': '/visualizations/_archetypes/clusterBar',
		'name': 'Bar',
		'description': 'Bar',
		'iconUri': '/visualizations/clusterBarChart/icon',
		'minimalVisId': 'barChart',
		'visIds': [
			'barChart',
			'clusterBarChart',
			'clusterBarChart2Measures',
			'clusterBarChart2MeasuresIgnoreColor'
		],
		'dataSlots': [{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'clusterBarChart',
				'clusterBarChart2MeasuresIgnoreColor'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		},
		{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'barChart',
				'clusterBarChart',
				'clusterBarChart2Measures',
				'clusterBarChart2MeasuresIgnoreColor'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Axis label',
			'id': 'categories',
			'icon': 'yAxis',
			'categoryTargets': [
				'barChart',
				'clusterBarChart',
				'clusterBarChart2Measures',
				'clusterBarChart2MeasuresIgnoreColor'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		},
		{
			'caption': 'Value',
			'id': 'valuesRepeating',
			'categoryTargets': [

			],
			'measureTargets': [
				'clusterBarChart2Measures',
				'clusterBarChart2MeasuresIgnoreColor'
			],
			'sortOrder': '4'
		}
		]
	},
	{
		'id': 'clusterColumn',
		'uri': '/visualizations/_archetypes/clusterColumn',
		'name': 'Column',
		'description': 'Column',
		'iconUri': '/visualizations/clusterColumnChart/icon',
		'minimalVisId': 'columnChart',
		'visIds': [
			'clusterColumnChart',
			'clusterColumnChart2Measures',
			'clusterColumnChart2MeasuresIgnoreColor',
			'columnChart'
		],
		'dataSlots': [{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'clusterColumnChart',
				'clusterColumnChart2MeasuresIgnoreColor'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		},
		{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'clusterColumnChart',
				'clusterColumnChart2Measures',
				'clusterColumnChart2MeasuresIgnoreColor',
				'columnChart'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Axis label',
			'id': 'categories',
			'categoryTargets': [
				'clusterColumnChart',
				'clusterColumnChart2Measures',
				'clusterColumnChart2MeasuresIgnoreColor',
				'columnChart'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		},
		{
			'caption': 'Value',
			'id': 'valuesRepeating',
			'categoryTargets': [

			],
			'measureTargets': [
				'clusterColumnChart2Measures',
				'clusterColumnChart2MeasuresIgnoreColor'
			],
			'sortOrder': '4'
		}
		]
	},
	{
		'id': 'clusterLine',
		'uri': '/visualizations/_archetypes/clusterLine',
		'name': 'Line',
		'description': 'Line',
		'iconUri': '/visualizations/clusterLineChart/icon',
		'minimalVisId': 'lineChart',
		'visIds': [
			'clusterLineChart',
			'lineChart',
			'multiLine2Measures',
			'multiLine2MeasuresIgnoreColor'
		],
		'dataSlots': [{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'clusterLineChart',
				'multiLine2MeasuresIgnoreColor'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		},
		{
			'caption': 'Vertical axis',
			'id': 'values',
			'icon': 'yAxis',
			'categoryTargets': [

			],
			'measureTargets': [
				'clusterLineChart',
				'lineChart',
				'multiLine2Measures',
				'multiLine2MeasuresIgnoreColor'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Horizontal axis',
			'id': 'categories',
			'icon': 'xAxis',
			'categoryTargets': [
				'clusterLineChart',
				'lineChart',
				'multiLine2Measures',
				'multiLine2MeasuresIgnoreColor'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		},
		{
			'caption': 'Value',
			'id': 'valuesRepeating',
			'categoryTargets': [

			],
			'measureTargets': [
				'multiLine2Measures',
				'multiLine2MeasuresIgnoreColor'
			],
			'sortOrder': '4'
		}
		]
	},
	{
		'id': 'crosstab',
		'uri': '/visualizations/_archetypes/crosstab',
		'name': 'Crosstab',
		'description': 'Crosstab',
		'iconUri': '/visualizations/crosstab/icon',
		'minimalVisId': 'crosstab',
		'visIds': [
			'crosstab'
		],
		'dataSlots': [{
			'caption': 'Heat by',
			'id': 'heat',
			'icon': 'heat',
			'categoryTargets': [

			],
			'measureTargets': [
				'crosstab'
			],
			'sortOrder': '99'
		},
		{
			'caption': 'Level One',
			'id': 'column_level1',
			'icon': 'column',
			'categoryTargets': [
				'crosstab'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		},
		{
			'caption': 'Level Two',
			'id': 'column_level2',
			'icon': 'column',
			'categoryTargets': [
				'crosstab'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		},
		{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'crosstab'
			],
			'sortOrder': '5'
		},
		{
			'caption': 'Level One',
			'id': 'row_level1',
			'icon': 'row',
			'categoryTargets': [
				'crosstab'
			],
			'measureTargets': [

			],
			'sortOrder': '3'
		},
		{
			'caption': 'Level Two',
			'id': 'row_level2',
			'icon': 'row',
			'categoryTargets': [
				'crosstab'
			],
			'measureTargets': [

			],
			'sortOrder': '4'
		}
		]
	},
	{
		'id': 'grid',
		'uri': '/visualizations/_archetypes/grid',
		'name': 'Grid',
		'description': 'Grid',
		'iconUri': '/visualizations/JQGrid/icon',
		'minimalVisId': 'JQGrid',
		'visIds': [
			'JQGrid'
		],
		'dataSlots': [{
			'caption': 'Heat by',
			'id': 'heat',
			'icon': 'heat',
			'categoryTargets': [

			],
			'measureTargets': [
				'JQGrid'
			],
			'sortOrder': '99'
		},
		{
			'caption': 'Column',
			'id': 'grid_cols',
			'categoryTargets': [
				'JQGrid'
			],
			'measureTargets': [
				'JQGrid'
			]
		}
		]
	},
	{
		'id': 'heat',
		'uri': '/visualizations/_archetypes/heat',
		'name': 'Heat',
		'description': 'Heat',
		'iconUri': '/visualizations/heatChart/icon',
		'minimalVisId': 'heatChart',
		'visIds': [
			'heatChart'
		],
		'dataSlots': [{
			'caption': 'Vertical axis',
			'id': 'yAxis',
			'icon': 'yAxis',
			'categoryTargets': [
				'heatChart'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		},
		{
			'caption': 'Horizontal axis',
			'id': 'xAxis',
			'icon': 'xAxis',
			'categoryTargets': [
				'heatChart'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		},
		{
			'caption': 'Heat by',
			'id': 'values',
			'icon': 'heat',
			'categoryTargets': [

			],
			'measureTargets': [
				'heatChart'
			],
			'sortOrder': '3'
		}
		]
	},
	{
		'id': 'hierarchy',
		'uri': '/visualizations/_archetypes/hierarchy',
		'name': 'Hierarchy',
		'description': 'Hierarchy',
		'iconUri': '/visualizations/hierarchy2/icon',
		'minimalVisId': 'list',
		'visIds': [
			'hierarchy2',
			'hierarchy3',
			'list'
		],
		'dataSlots': [{
			'caption': 'Level One',
			'id': 'level1',
			'icon': 'hierarchy',
			'categoryTargets': [
				'hierarchy2',
				'hierarchy3',
				'list'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		},
		{
			'caption': 'Level Three',
			'id': 'level3',
			'icon': 'hierarchy',
			'categoryTargets': [
				'hierarchy3'
			],
			'measureTargets': [

			],
			'sortOrder': '3'
		},
		{
			'caption': 'Level Two',
			'id': 'level2',
			'icon': 'hierarchy',
			'categoryTargets': [
				'hierarchy2',
				'hierarchy3'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		}
		]
	},
	{
		'id': 'lineColumnCombo',
		'uri': '/visualizations/_archetypes/lineColumnCombo',
		'name': 'Line and Column',
		'description': 'Line and Column',
		'iconUri': '/visualizations/lineColumnComboChart/icon',
		'minimalVisId': 'lineColumnComboChart',
		'visIds': [
			'lineColumnComboChart'
		],
		'dataSlots': [{
			'caption': 'Line Value',
			'id': 'lineValue',
			'categoryTargets': [

			],
			'measureTargets': [
				'lineColumnComboChart'
			],
			'sortOrder': '2'
		},
		{
			'caption': 'Axis label',
			'id': 'category',
			'categoryTargets': [
				'lineColumnComboChart'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		},
		{
			'caption': 'Column Value',
			'id': 'columnValue',
			'categoryTargets': [

			],
			'measureTargets': [
				'lineColumnComboChart'
			],
			'sortOrder': '3'
		}
		]
	},
	{
		'id': 'map',
		'uri': '/visualizations/_archetypes/map',
		'name': 'Map',
		'description': 'Map',
		'iconUri': '/visualizations/map1measure/icon',
		'minimalVisId': 'map1measure',
		'visIds': [
			'map1measure',
			'map2measure',
			'map3measure'
		],
		'dataSlots': [{
			'caption': 'Point Size',
			'id': 'size',
			'icon': 'sizeBy',
			'categoryTargets': [

			],
			'measureTargets': [
				'map2measure',
				'map3measure'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Region Heat',
			'id': 'values',
			'icon': 'heat',
			'categoryTargets': [

			],
			'measureTargets': [
				'map1measure',
				'map2measure',
				'map3measure'
			],
			'sortOrder': '2'
		},
		{
			'caption': 'Point Heat',
			'id': 'sizeHeat',
			'icon': 'heat',
			'categoryTargets': [

			],
			'measureTargets': [
				'map3measure'
			],
			'sortOrder': '4'
		},
		{
			'caption': 'Regions',
			'id': 'categories',
			'icon': 'location',
			'categoryTargets': [
				'map1measure',
				'map2measure',
				'map3measure'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		}
		]
	},
	{
		'id': 'packedBubble',
		'uri': '/visualizations/_archetypes/packedBubble',
		'name': 'Packed Bubble',
		'description': 'Packed Bubble',
		'iconUri': '/visualizations/packedBubbleChart1Cat/icon',
		'minimalVisId': 'packedBubbleChart1Cat',
		'visIds': [
			'packedBubbleChart1Cat',
			'packedBubbleChart2Cat'
		],
		'dataSlots': [{
			'caption': 'Size by',
			'id': 'size',
			'icon': 'sizeBy',
			'categoryTargets': [

			],
			'measureTargets': [
				'packedBubbleChart1Cat',
				'packedBubbleChart2Cat'
			],
			'sortOrder': '2'
		},
		{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'packedBubbleChart2Cat'
			],
			'measureTargets': [

			],
			'sortOrder': '3'
		},
		{
			'caption': 'Categories',
			'id': 'categories',
			'categoryTargets': [
				'packedBubbleChart1Cat',
				'packedBubbleChart2Cat'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		}
		]
	},
	{
		'id': 'pie',
		'uri': '/visualizations/_archetypes/pie',
		'name': 'Pie',
		'description': 'Pie',
		'iconUri': '/visualizations/pieChart/icon',
		'minimalVisId': 'pieChart',
		'visIds': [
			'pieChart'
		],
		'dataSlots': [{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'pieChart'
			],
			'sortOrder': '2'
		},
		{
			'caption': 'Categories',
			'id': 'categories',
			'categoryTargets': [
				'pieChart'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		}
		]
	},
	{
		'id': 'player',
		'uri': '/visualizations/_archetypes/player',
		'name': 'Data Player',
		'description': 'Data Player',
		'iconUri': '/visualizations/dataPlayer/icon',
		'minimalVisId': 'dataPlayer',
		'visIds': [
			'dataPlayer'
		],
		'dataSlots': [{
			'caption': 'Axis label',
			'id': 'categories',
			'categoryTargets': [
				'dataPlayer'
			],
			'measureTargets': [

			]
		}]
	},
	{
		'id': 'point',
		'uri': '/visualizations/_archetypes/point',
		'name': 'Point',
		'description': 'Point',
		'iconUri': '/visualizations/pointChart1cat/icon',
		'minimalVisId': 'pointChart1cat',
		'visIds': [
			'pointChart1cat',
			'pointChart2cat'
		],
		'dataSlots': [{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'pointChart2cat'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		},
		{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'pointChart1cat',
				'pointChart2cat'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Axis label',
			'id': 'categories',
			'categoryTargets': [
				'pointChart1cat',
				'pointChart2cat'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		}
		]
	},
	{
		'id': 'radial',
		'uri': '/visualizations/_archetypes/radial',
		'name': 'Radial',
		'description': 'Radial',
		'iconUri': '/visualizations/radialChart/icon',
		'minimalVisId': 'radialChart',
		'visIds': [
			'radialChart',
			'radialTargetChart'
		],
		'dataSlots': [{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'radialChart',
				'radialTargetChart'
			],
			'sortOrder': '2'
		},
		{
			'caption': 'Maximum Value',
			'id': 'maxSize',
			'categoryTargets': [

			],
			'measureTargets': [
				'radialTargetChart'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Categories',
			'id': 'categories',
			'categoryTargets': [
				'radialChart',
				'radialTargetChart'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		}
		]
	},
	{
		'id': 'radialBar',
		'uri': '/visualizations/_archetypes/radialBar',
		'name': 'Radial Bar',
		'description': 'Radial Bar',
		'iconUri': '/visualizations/radialBarChart/icon',
		'minimalVisId': 'radialBarChart',
		'visIds': [
			'radialBarChart'
		],
		'dataSlots': [{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'radialBarChart'
			],
			'sortOrder': '2'
		},
		{
			'caption': 'Categories',
			'id': 'categories',
			'categoryTargets': [
				'radialBarChart'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		}
		]
	},
	{
		'id': 'scatterPlot',
		'uri': '/visualizations/_archetypes/scatterPlot',
		'name': 'Scatter Plot',
		'description': 'Scatter Plot',
		'iconUri': '/visualizations/scatterPlotChart/icon',
		'minimalVisId': 'scatterPlotChartNoCat',
		'visIds': [
			'scatterPlotChart',
			'scatterPlotChart2Cat',
			'scatterPlotChartNoCat'
		],
		'dataSlots': [{
			'caption': 'Vertical axis',
			'id': 'yAxis',
			'icon': 'yAxis',
			'categoryTargets': [

			],
			'measureTargets': [
				'scatterPlotChart',
				'scatterPlotChart2Cat',
				'scatterPlotChartNoCat'
			],
			'sortOrder': '4'
		},
		{
			'caption': 'Horizontal axis',
			'id': 'xAxis',
			'icon': 'xAxis',
			'categoryTargets': [

			],
			'measureTargets': [
				'scatterPlotChart',
				'scatterPlotChart2Cat',
				'scatterPlotChartNoCat'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'scatterPlotChart2Cat'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		},
		{
			'caption': 'Points',
			'id': 'categories',
			'icon': 'points',
			'categoryTargets': [
				'scatterPlotChart',
				'scatterPlotChart2Cat'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		}
		]
	},
	{
		'id': 'stackedBar',
		'uri': '/visualizations/_archetypes/stackedBar',
		'name': 'Stack Bar',
		'description': 'Stack Bar',
		'iconUri': '/visualizations/stackBarChart/icon',
		'minimalVisId': 'barChart',
		'visIds': [
			'barChart',
			'stackBarChart',
			'stackBarChart2Measures',
			'stackedBarChart2MeasuresIgnoreColor'
		],
		'dataSlots': [{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'stackBarChart',
				'stackedBarChart2MeasuresIgnoreColor'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		},
		{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'barChart',
				'stackBarChart',
				'stackBarChart2Measures',
				'stackedBarChart2MeasuresIgnoreColor'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Axis label',
			'id': 'categories',
			'icon': 'yAxis',
			'categoryTargets': [
				'barChart',
				'stackBarChart',
				'stackBarChart2Measures',
				'stackedBarChart2MeasuresIgnoreColor'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		},
		{
			'caption': 'Value',
			'id': 'valuesRepeating',
			'categoryTargets': [

			],
			'measureTargets': [
				'stackBarChart2Measures',
				'stackedBarChart2MeasuresIgnoreColor'
			],
			'sortOrder': '4'
		}
		]
	},
	{
		'id': 'stackedColumn',
		'uri': '/visualizations/_archetypes/stackedColumn',
		'name': 'Stack Column',
		'description': 'Stack Column',
		'iconUri': '/visualizations/stackColumnChart/icon',
		'minimalVisId': 'columnChart',
		'visIds': [
			'columnChart',
			'stackColumnChart',
			'stackColumnChart2Measures',
			'stackColumnChart2MeasuresIgnoreColor'
		],
		'dataSlots': [{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'stackColumnChart',
				'stackColumnChart2MeasuresIgnoreColor'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		},
		{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'columnChart',
				'stackColumnChart',
				'stackColumnChart2Measures',
				'stackColumnChart2MeasuresIgnoreColor'
			],
			'sortOrder': '3'
		},
		{
			'caption': 'Axis label',
			'id': 'categories',
			'categoryTargets': [
				'columnChart',
				'stackColumnChart',
				'stackColumnChart2Measures',
				'stackColumnChart2MeasuresIgnoreColor'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		},
		{
			'caption': 'Value',
			'id': 'valuesRepeating',
			'categoryTargets': [

			],
			'measureTargets': [
				'stackColumnChart2Measures',
				'stackColumnChart2MeasuresIgnoreColor'
			],
			'sortOrder': '4'
		}
		]
	},
	{
		'id': 'summaryChart',
		'uri': '/visualizations/_archetypes/summaryChart',
		'name': 'Summary',
		'description': 'Summary',
		'iconUri': '/visualizations/summary/icon',
		'minimalVisId': 'summary',
		'visIds': [
			'summary'
		],
		'dataSlots': [{
			'caption': 'Value',
			'id': 'values',
			'categoryTargets': [

			],
			'measureTargets': [
				'summary'
			]
		}]
	},
	{
		'id': 'treeMap',
		'uri': '/visualizations/_archetypes/treeMap',
		'name': 'Tree Map',
		'description': 'Tree Map',
		'iconUri': '/visualizations/treeMap1Cat1MeasureChart/icon',
		'minimalVisId': 'treeMap1Cat1MeasureChart',
		'visIds': [
			'treeMap1Cat1MeasureChart',
			'treeMap1Cat2MeasureChart',
			'treeMap2Cat1MeasureChart',
			'treeMap2Cat2MeasureChart',
			'treeMap3Cat1MeasureChart',
			'treeMap3Cat2MeasureChart'
		],
		'dataSlots': [{
			'caption': 'Heat by',
			'id': 'color',
			'icon': 'heat',
			'categoryTargets': [

			],
			'measureTargets': [
				'treeMap1Cat2MeasureChart',
				'treeMap2Cat2MeasureChart',
				'treeMap3Cat2MeasureChart'
			]
		},
		{
			'caption': 'Size by',
			'id': 'values',
			'icon': 'sizeBy',
			'categoryTargets': [

			],
			'measureTargets': [
				'treeMap1Cat1MeasureChart',
				'treeMap1Cat2MeasureChart',
				'treeMap2Cat1MeasureChart',
				'treeMap2Cat2MeasureChart',
				'treeMap3Cat1MeasureChart',
				'treeMap3Cat2MeasureChart'
			]
		},
		{
			'caption': 'Level One',
			'id': 'categories',
			'icon': 'hierarchy',
			'categoryTargets': [
				'treeMap1Cat1MeasureChart',
				'treeMap1Cat2MeasureChart',
				'treeMap2Cat1MeasureChart',
				'treeMap2Cat2MeasureChart',
				'treeMap3Cat1MeasureChart',
				'treeMap3Cat2MeasureChart'
			],
			'measureTargets': [

			],
			'sortOrder': '1'
		},
		{
			'caption': 'Level Three',
			'id': 'level3',
			'icon': 'hierarchy',
			'categoryTargets': [
				'treeMap3Cat1MeasureChart',
				'treeMap3Cat2MeasureChart'
			],
			'measureTargets': [

			],
			'sortOrder': '3'
		},
		{
			'caption': 'Level Two',
			'id': 'level2',
			'icon': 'hierarchy',
			'categoryTargets': [
				'treeMap2Cat1MeasureChart',
				'treeMap2Cat2MeasureChart',
				'treeMap3Cat1MeasureChart',
				'treeMap3Cat2MeasureChart'
			],
			'measureTargets': [

			],
			'sortOrder': '2'
		}
		]
	},
	{
		'id': 'wordCloud',
		'uri': '/visualizations/_archetypes/wordCloud',
		'name': 'Word Cloud',
		'description': 'Word Cloud',
		'iconUri': '/visualizations/wordChart1Cat1Measure/icon',
		'minimalVisId': 'wordChart1Cat1Measure',
		'visIds': [
			'wordChart1Cat1Measure',
			'wordChart1Cat2Measures',
			'wordChart2Cat1Measures'
		],
		'dataSlots': [{
			'caption': 'Color by',
			'id': 'color',
			'icon': 'colorBy',
			'categoryTargets': [
				'wordChart2Cat1Measures'
			],
			'measureTargets': [
				'wordChart1Cat2Measures'
			]
		},
		{
			'caption': 'Size by',
			'id': 'scale',
			'icon': 'sizeBy',
			'categoryTargets': [

			],
			'measureTargets': [
				'wordChart1Cat1Measure',
				'wordChart1Cat2Measures',
				'wordChart2Cat1Measures'
			]
		},
		{
			'caption': 'Words',
			'id': 'word',
			'icon': 'rows',
			'categoryTargets': [
				'wordChart1Cat1Measure',
				'wordChart1Cat2Measures',
				'wordChart2Cat1Measures'
			],
			'measureTargets': [

			]
		}
		]
	}
	];

	var utils = {
		getArcheTypeFromVizId: function(visId) {
			var result = _.find(ArcheType, function(entry) {
				return entry.visIds.indexOf(visId) >= 0;
			});
			if (result) {
				return result.id;
			} else {
				return null;
			}
		}
	};

	return utils;
});
